"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BtPlanRow = BtPlanRow;
var _react = _interopRequireDefault(require("react"));
var _elements = require("@reservamos/elements");
/** Render one selectable installment option. */
function BtPlanRow(_ref) {
  var checked = _ref.checked,
    label = _ref.label,
    onSelect = _ref.onSelect,
    tag = _ref.tag,
    _ref$tagVariant = _ref.tagVariant,
    tagVariant = _ref$tagVariant === void 0 ? 'with' : _ref$tagVariant;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-[10px] rounded-[15px] border border-gray-200 bg-white",
    "data-sentry-component": "BtPlanRow",
    "data-sentry-source-file": "BtPlanRow.tsx"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "flex min-h-[60px] cursor-pointer items-center rounded-[15px] px-5 transition-all duration-300 ease-in-out hover:bg-gray-100 ".concat(checked ? 'ring-1 ring-inset ring-accent-regular' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex min-w-0 flex-1 items-center"
  }, label, tag && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-auto mr-4 whitespace-nowrap"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: tagVariant === 'free' ? 'success' : 'grayStrong'
  }, tag))), /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    name: "bt-installments-plan",
    className: "sr-only",
    checked: checked,
    onChange: onSelect
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-6 w-6 flex-shrink-0 items-center justify-center",
    "aria-hidden": "true"
  }, checked ? /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Success",
    color: "success",
    size: "M"
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "h-6 w-6 rounded-full border border-gray-200 bg-gray-100"
  }))));
}